import { DateRange } from "@angular/material/datepicker";
import { createReducer, on } from "@ngrx/store";
import { Lot } from "src/app/+state/lots/lot";
import * as fromRoot from '../reducers';
import { fetchLotsSuccess, fetchLotSuccess, updateTableFilter, amountsFetched, fetchBeekeeperProductsSuccess } from "./lot.actions";
import { HarvestAmount } from "src/app/honey-house/harvest-amount";
import { BeekeeperProducts } from "src/app/honey-house/beekeeper-products";

export interface State extends fromRoot.State {
  lots: LotsState;
}

export interface LotsTableFilter {
  query: string;
  dateRange: DateRange<Date>;
  publicStatus: boolean | null;
}

export interface LotsState {
  lots: Lot[];
  tableFilter: LotsTableFilter;
  lotAmounts: HarvestAmount[];
  connectLotLoading: boolean;
  beekeeperProducts: BeekeeperProducts[];
}

const initialState: LotsState = {
  lots: [],
  tableFilter: {
    query: '',
    dateRange: null,
    publicStatus: null
  },
  lotAmounts: [],
  connectLotLoading: false,
  beekeeperProducts: [],
}

export const LotsReducer = createReducer(
  initialState,

  // All lots loaded
  on(fetchLotsSuccess, (state, { lots }) => ({
    ...state,
    lots,
  })),

  // One lot loaded (insert it into the lots list)
  // NOTE: seems strange - refactor?
  on(fetchLotSuccess, (state, { lot }) => {
    const lotIndex = state.lots.findIndex(_lot => _lot.id === lot.id);
    const lots = [...state.lots];
    if (lotIndex < 0) {
      lots.push(lot);
    } else {
      lots[lotIndex] = lot;
    }
    return { ...state, lots };
  }),

  on(updateTableFilter, (state, { tableFilter }) => ({
    ...state,
    tableFilter
  })),

  on(amountsFetched, (state, { response }) => {
    return ({
      ...state,
      lotAmounts: response
    })
  }),

  // Beekeeper products loaded
  on(fetchBeekeeperProductsSuccess, (state, { beekeeperProducts }) => ({
    ...state,
    beekeeperProducts,
  })),
)
